// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"z9-z"};